import React from 'react'
import Translator from '../../../../../../../../../requests/apa/Translator'
import Utils from '../../../../../../../../../utils/Utils'
import './_styles.scss'

/**
 * StatsPlayerCard
 * Tarjeta de estadísticas de jugador.
 * Diseño: Figma node 133:24906 (1rem = 15px)
 *
 * Props:
 *  playerName    {string} — nombre del jugador
 *  jerseyNumber  {number} — dorsal
 *  photoUrl      {string} — URL de la foto del jugador
 *  stats         {object} — estadísticas: { g, pag, tt, tap, pt, re, fr, fj }
 */
function StatsPlayerCard (props) {
  var playerName = props.playerName
  var jerseyNumber = props.jerseyNumber
  var photoUrl = props.photoUrl
  var stats = props.stats
  var className = 'stats-player-card' + (props.className ? ' ' + props.className : '')
  var tabSelected = props.tabSelected

  const STAT_COLUMNS_OFFENSIVE = [
    { key: 'g',   label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_goles'), 5) },
    { key: 'pag', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_pasesgol'), 5) },
    { key: 'tt',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_tirostotales'), 5) },
    { key: 'tap', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_tirosporteria'), 5) },    
    { key: 'pt',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_pasestotales'), 5) },
    { key: 're',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_regatesexito'), 5) },
    { key: 'fr',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_faltasrecibidas'), 5) },
    { key: 'fj',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_fueradejuego'), 5) }    
  ]
  const STAT_COLUMNS_DEFENSIVE = [
    { key: 'i',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_intercepciones'), 5) },
    { key: 'eg', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_entradasganadas'), 5) },
    { key: 'fc', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_faltascometidas'), 5) },
    { key: 'ta', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_tarjetasamarillas'), 5) }
  ]
  const STAT_COLUMNS_GOALKEEPING = [
    { key: 'pp', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_paradasportero'), 5) },
    { key: 'pac', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_porteriacero'), 5) }
  ]

  var TOTAL_COLUMNS = 8
  var dataColumns = STAT_COLUMNS_OFFENSIVE
  if (tabSelected === 'defenses') dataColumns = STAT_COLUMNS_DEFENSIVE
  else if (tabSelected === 'goalkeeper') dataColumns = STAT_COLUMNS_GOALKEEPING

  var emptyCount = TOTAL_COLUMNS - dataColumns.length
  var columnsToUse = []
  for (var _i = 0; _i < emptyCount; _i++) {
    columnsToUse.push({ key: '__empty_' + _i, label: '', empty: true })
  }
  columnsToUse = columnsToUse.concat(dataColumns)

  return (
    <div className={className}>
      <div className='stats-player-card__header-overlay' />
      <img
        className='stats-player-card__photo'
        src={photoUrl}
        alt={playerName}
      />
      <div className='stats-player-card__divider' />
      <p className='stats-player-card__name'>{playerName}</p>
      <p className='stats-player-card__number'># {jerseyNumber}</p>

      <div className='stats-player-card__labels-bg' />
      <div className='stats-player-card__values-bg' />

      <div className='stats-player-card__labels-row'>
        {columnsToUse.map(function (col, i) {
          return (
            <div
              key={col.key}
              className={'stats-player-card__cell' + (i === emptyCount ? ' stats-player-card__cell--first' : '')}
            >
              <span className='stats-player-card__label-text'>{col.label}</span>
            </div>
          )
        })}
      </div>

      <div className='stats-player-card__values-row'>
        {columnsToUse.map(function (col, i) {
          return (
            <div
              key={col.key}
              className={'stats-player-card__cell stats-player-card__cell--value' + (i === emptyCount ? ' stats-player-card__cell--first' : '')}
            >
              <span className='stats-player-card__value-text'>{col.empty ? '' : stats[col.key]}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default StatsPlayerCard



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StatsPlayerCard/index.jsx